import Stack from '@mui/material/Stack';
import { useMediaQuery, useTheme } from '@mui/material';

import { Mask } from '@hapvida/hapvida-core-components';

import { Label } from './styles';
import type { DetailContractProps } from './types';

export const DetailContract: React.FC<DetailContractProps> = ({
  data,
}: Readonly<DetailContractProps>) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), {
    noSsr: true,
  });
  return (
    <Stack>
      {isMobile ? (
        <>
          <Label fontSize="14px" fontWeight={700} mb={1.5}>
            {Mask.cnpj(data?.unitDocument)}
          </Label>
          <Stack direction="row" alignItems="center" mb={1.5}>
            <Label fontSize="12px">
              {(data.partnerCompany ?? data.number)?.toString()}
            </Label>
          </Stack>
          <Label fontSize="12px">
            Unidade: <strong>{data.unitCode ?? '-'}</strong>
          </Label>
        </>
      ) : (
        <>
          <Stack direction="row" alignItems="center">
            <Label fontSize="12px">
              {(data.partnerCompany ?? data.number)?.toString()}
            </Label>
          </Stack>
          <Label fontSize="14px" fontWeight={700}>
            {Mask.cnpj(data?.unitDocument, true)}
          </Label>
          <Label fontSize="12px">
            Unidade: <strong>{data.unitCode ?? '-'}</strong>
          </Label>
        </>
      )}
    </Stack>
  );
};
